import {
  AccountName,
  CoinName,
  DisplayCurrenciesToNumber,
  ExchangeName,
  RawLineChartDataPoint,
  SingleValueChartData,
  TimeRange,
} from "@shared/types";

export type GraphDataType = {
  [key in TimeRange]: LineChartDataPointWithExchange[];
};

export interface AccountsTradesStatistics {
  trade: {
    [key in AccountName]: AccountTradesStatistics;
  };
}

export interface AccountTradesStatistics {
  amount_change: DisplayCurrenciesToNumber;
  exchange: ExchangeName;
  number_of_trades: number;
  potential_profit: DisplayCurrenciesToNumber;
  trades_allocated: DisplayCurrenciesToNumber;
}

export type LineChartDataPointWithExchange = [
  unixTimestamp: number,
  exchangeName: string,
  price: number
];

export type TopMarketsData = {
  [key in ExchangeName]: TopMarketsTabsData;
};

export interface TopMarketsTabsData {
  top_gainers: TopMarketsTableData[];
  top_losers: TopMarketsTableData[];
  top_volume: TopMarketsTableData[];
}

export interface TopMarketsTableData {
  exchange: ExchangeName;
  graph_data: SingleValueChartData;
  high_price: [number, number];
  low_price: [number, number];
  price: number;
  symbol: CoinName;
  volume: [number, number];
}

export type TopMarketsTableDataBySymbol = Pick<
  TopMarketsTableData,
  "high_price" | "low_price" | "price" | "volume" | "symbol"
> & {
  exchanges: ExchangeName[];
  change: number;
  graph_data: RawLineChartDataPoint[];
};

export enum TopMarketsTabs {
  VOLUME = "market.tab.volume",
  TOP_GAINERS = "market.tab.top_gainers",
  TOP_LOSERS = "market.tab.top_losers",
}

type ExchangeActivitySummary = {
  amount_change: { BTC: number; USD: number };
  trades_allocated: { BTC: number; USD: number };
  exchange: string;
  number_of_trades: number;
};

type ActivitySummary = { [accountName: string]: ExchangeActivitySummary };

export interface AssetSummary {
  [coinName: string]: {
    BTC: [number, number, number];
    USD: [number, number, number];
  };
}

export interface BearBullData {
  bear: number;
  bull: number;
}

export interface DashboardData {
  activity_summary: ActivitySummary;
  asset_summary: AssetSummary;
  bear_bull: BearBullData;
}
